import AdminWrapper from '@/admin/components/addmin-wrapper/AdminWrapper';
import ServiceRequestComp from '@/admin/components/service-request-comp/ServiceRequestComp';
import DataNotFound from '@/components/data-not-found/DataNotFound';
import Spinner from '@/components/spinner/Spinner';
import useGetApiReq from '@/hooks/useGetApiReq';
import { useEffect, useState } from 'react'

import {
    Table,
    TableBody,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table"

const Dashboard = () => {
    const { res, fetchData, isLoading } = useGetApiReq();

    const [allRequests, setAllRequests] = useState([]);

    const getRecentRequests = async () => {
        fetchData("/admin/get-recent-requests");
    }

    useEffect(() => {
        getRecentRequests();
    }, [])

    useEffect(() => {
        if (res?.status === 200 || res?.status === 201) {
            console.log("requests res",res);
            setAllRequests(res?.data?.requests);
        }
    }, [res])


    return (
        <AdminWrapper>
            <div>
                <div className="section-heading-container">
                    <h1 className='section-heading'>Recent Requests</h1>
                </div>
                <Table className="mt-4">
                    <TableHeader className="bg-[#E5E7EB]">
                        <TableRow className="text-lg">
                            <TableHead>Client Name</TableHead>
                            <TableHead>Client Phone No</TableHead>
                            <TableHead>Service Name</TableHead>
                            <TableHead>Service Cost</TableHead>
                            <TableHead>Status</TableHead>
                            <TableHead>Date</TableHead>
                            <TableHead>Actions</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {allRequests?.map((request) => (
                            <ServiceRequestComp
                                key={request._id}
                                serviceRequest={request}
                                getServiceRequests={getRecentRequests}
                            />
                        ))}
                    </TableBody>
                </Table>
                {allRequests.length === 0 && isLoading &&
                    <Spinner size={30} />
                }

                {allRequests.length === 0 && !isLoading &&
                    <DataNotFound name={"Requests"} />
                }
            </div>
        </AdminWrapper>
    )
}

export default Dashboard